import React from "react";

function ReportsSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.56"
      height="23.974"
      viewBox="0 0 20.56 23.974"
    >
      <g id="XMLID_74_" transform="translate(-38 -0.1)">
        <path
          id="XMLID_170_"
          d="M345.51,70.047h2.435L345,67.2v2.4A.5.5,0,0,0,345.51,70.047Z"
          transform="translate(-292.622 -63.957)"
          fill="none"
        />
        <path
          id="XMLID_174_"
          d="M91.015,46.09a2.354,2.354,0,0,1-2.384-2.323V40.128L78.487,40.1a.493.493,0,0,0-.487.468V59.854a.523.523,0,0,0,.51.478H94.387a.451.451,0,0,0,.426-.478V46.09Zm-1.681,3.7a.937.937,0,1,1,0,1.873h-8.2a.937.937,0,0,1,0-1.873Zm-8.243-3.747h5.433a.937.937,0,1,1,0,1.873H81.091a.937.937,0,1,1,0-1.873ZM91.675,55.41H81.138a.937.937,0,0,1,0-1.873H91.675a.937.937,0,0,1,0,1.873Z"
          transform="translate(-38.127 -38.127)"
          fill="none"
        />
        <path
          id="XMLID_488_"
          d="M58.1,6.174,52.4.657A1.882,1.882,0,0,0,51.095.128L40.36.1A2.353,2.353,0,0,0,38,2.442V21.728a2.4,2.4,0,0,0,2.384,2.346H56.26a2.327,2.327,0,0,0,2.3-2.351V7.294A1.54,1.54,0,0,0,58.1,6.174ZM52.378,3.243,55.324,6.09H52.888a.5.5,0,0,1-.51-.45ZM56.26,22.2H40.384a.519.519,0,0,1-.51-.478V2.442a.493.493,0,0,1,.487-.468L50.5,2V5.64a2.357,2.357,0,0,0,2.384,2.323h3.8v13.76A.451.451,0,0,1,56.26,22.2Z"
          // fill="#023a6c"
        />
        <path
          id="XMLID_490_"
          d="M125,247.937a.939.939,0,0,0,.937.937h8.2a.937.937,0,1,0,0-1.873h-8.2A.939.939,0,0,0,125,247.937Z"
          transform="translate(-82.925 -235.337)"
          //   fill="#023a6c"
        />
        <path
          id="XMLID_491_"
          d="M124.937,168.873h5.433a.937.937,0,1,0,0-1.873h-5.433a.937.937,0,0,0,0,1.873Z"
          transform="translate(-81.972 -159.083)"
          //   fill="#023a6c"
        />
        <path
          id="XMLID_492_"
          d="M136.474,327H125.937a.937.937,0,0,0,0,1.873h10.538a.937.937,0,0,0,0-1.873Z"
          transform="translate(-82.925 -311.59)"
          //   fill="#023a6c"
        />
      </g>
    </svg>
  );
}

export default ReportsSvg;
